// Default dashboard widget configuration
export const DEFAULT_DASHBOARD_WIDGETS = [
  { id: "kpis", label: "KPI cards", visible: true, settings: { showTrends: true, showIcons: true, layout: "four", density: "comfortable", graphColumns: 2, tableColumns: 2, kpiVisibility: { totalReports: true, totalPersonas: true, totalUsers: true, totalActiveUsers: true, totalViews: false, inactiveUsers: false, unusedReports: false, topReportViews: false, topVisualUses: false, averageViewsPerUser: false } } },
  { id: "viewsByPersona", label: "Views by persona", visible: true, settings: { showLegend: true, showGrid: true, size: "full", height: 400, rowLayout: "single", split: "50" } },
  { id: "dailyActivity", label: "Daily activity graph", visible: true, settings: { chartType: "bar", showLegend: false, showGrid: true, size: "wide", height: 400, rowLayout: "two", split: "50" } },
  { id: "reportDistribution", label: "Report distribution graph", visible: true, settings: { showLegend: true, chartType: "donut", size: "standard", height: 400, rowLayout: "two", split: "50" } },
  { id: "topReportsGraph", label: "Top reports performance graph", visible: true, settings: { showLegend: false, showGrid: true, size: "standard", height: 400, rowLayout: "two", split: "50" } },
  { id: "userActivityGraph", label: "User activity graph", visible: true, settings: { showLegend: false, showGrid: true, size: "standard", height: 400, rowLayout: "two", split: "50" } },
  { id: "topReports", label: "Top reports table", visible: true, settings: { pageSize: 10, showBars: true, size: "standard" } },
  { id: "topVisuals", label: "Top visuals table", visible: true, settings: { pageSize: 10, showBars: true, size: "standard" } },
  { id: "userActivity", label: "User activity table", visible: true, settings: { pageSize: 10, showBars: true, size: "full" } },
  { id: "inactiveUsers", label: "Inactive users table", visible: true, settings: { pageSize: 10, size: "full" } },
  { id: "unusedReports", label: "Unused reports table", visible: true, settings: { pageSize: 10, size: "full" } },
  { id: "customizer", label: "Customizer settings", visible: true, settings: { selectedKpiSlots: [null, null, null, null], customLayouts: [] } },
];

// Graph options for customizer
export const GRAPH_OPTIONS = [
  { id: "viewsByPersona", label: "Views by persona" },
  { id: "dailyActivity", label: "Daily activity" },
  { id: "reportDistribution", label: "Report distribution" },
  { id: "topReportsGraph", label: "Top reports performance" },
  { id: "userActivityGraph", label: "User activity" },
];

// Table options for customizer
export const TABLE_OPTIONS = [
  { id: "topReports", label: "Top reports" },
  { id: "topVisuals", label: "Top visuals" },
  { id: "userActivity", label: "User activity" },
  { id: "inactiveUsers", label: "Inactive users" },
  { id: "unusedReports", label: "Unused reports" },
];

// Table column configurations
export const TABLE_COLUMNS = {
  topReports: [
    { key: "index", header: "#", align: "left" },
    { key: "reportName", header: "Report", align: "left", truncate: true, maxWidth: 150 },
    { key: "userGroupName", header: "Group", align: "left", badge: true },
    { key: "count", header: "Views", align: "right" },
  ],
  topVisuals: [
    { key: "index", header: "#", align: "left" },
    { key: "title", header: "Visual", align: "left", truncate: true, maxWidth: 180 },
    { key: "saveCount", header: "Uses", align: "right" },
  ],
  userActivity: [
    { key: "index", header: "#", align: "left" },
    { key: "email", header: "User", align: "left", truncate: true, maxWidth: 180 },
    { key: "views", header: "Views", align: "right" },
  ],
  inactiveUsers: [
    { key: "index", header: "#", align: "left" },
    { key: "email", header: "User", align: "left", truncate: true, maxWidth: 150 },
    { key: "lastActivity", header: "Last Active", align: "left", fallback: "Never" },
  ],
  unusedReports: [
    { key: "index", header: "#", align: "left" },
    { key: "reportName", header: "Report", align: "left", truncate: true, maxWidth: 150 },
    { key: "userGroupName", header: "Group", align: "left", badge: true },
  ],
};

// Table styling configuration
// Header colors are now pulled from uiConfig.js (tableAccentColor, tableAccentBackground)
export const TABLE_STYLES = {
  row: {
    border: "border-slate-100",
    hover: "hover:bg-slate-50",
    text: "text-slate-700",
    indexText: "text-slate-400",
  },
  badge: {
    topReports: "bg-indigo-50 text-indigo-600",
    unusedReports: "bg-amber-50 text-amber-600",
    default: "bg-slate-50 text-slate-600",
  },
};

// Default chart palette
export const PERSONA_BAR_PALETTE = ["#bb1ccc", "#5e0768", "#0ea5e9", "#f59e0b", "#10b981"];
